@if (status() == 'ready') {
  <ng-content></ng-content>
} @else {
  <mibp-loader type="loader"></mibp-loader>
}
